import classNames from "classnames";

import styles from "./List.module.scss";

import ListRow from "../../components/ListRow/ListRow";

const List = ({ title, items, val }) => {
  const handleSelectRange = () => {};
  return (
    <div className={styles.list}>
      <h2>{title}</h2>
      {items.map((item, index) => (
        <ListRow key={index} {...item} val={val} />
      ))}
    </div>
  );
};

export default List;
